// ── Toast hook ────────────────────────────────────────────────────────────────
import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'warn' | 'info';

interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

interface ToastStore {
  toasts: Toast[];
  add:    (message: string, type?: ToastType, duration?: number) => void;
  remove: (id: string) => void;
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  add: (message, type = 'success', duration = 3500) => {
    const id = Math.random().toString(36).slice(2);
    set(s => ({ toasts: [...s.toasts, { id, message, type }] }));
    setTimeout(() => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })), duration);
  },
  remove: (id) => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })),
}));

/** Convenience: call toast(msg) anywhere — no React context needed */
export const toast = (message: string, type: ToastType = 'success', duration?: number) =>
  useToastStore.getState().add(message, type, duration);
